import { DialogModeEnum } from '@app/shared/types/enums/dialog-mode.enum';

export interface UpdateProjectTagRequestBody {
  id: string;
  name: string;
  hexColor: string;
  description: string;
}

export interface CreateProjectTagRequestBody {
  name: string;
  hexColor: string;
  description: string;
  projectId: string;
}

export interface TagFormDialogData {
  projectTagToEdit?: Tag;
  mode?: DialogModeEnum;
}

/** Signal Forms model of the create / edit tag dialog. */
export interface TagFormModel {
  id: string;
  hexColor: string;
  name: string;
  description: string;
}

export class Tag {
  public description: string | undefined;
  public hexColor: string;
  public id: string;
  public name: string;
  public projectId: string;

  public constructor(value: Partial<Tag>) {
    Object.assign(this, value);
  }
}
